var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, useMemo, useCallback, } from "react";
import { Tree, Input, Card, Space, Button, Typography, Empty, Dropdown, Menu, } from "antd";
import { EllipsisOutlined, ReloadOutlined, CaretRightOutlined, CaretDownOutlined, EditOutlined, DeleteOutlined, SearchOutlined, } from "@ant-design/icons";
var Search = Input.Search;
var Text = Typography.Text;
// 修改全局样式，添加调整间距的CSS
// 修改全局样式，调整箭头方向
var globalStyles = "\n  .tree-panel .ant-tree .ant-tree-list .ant-tree-list-holder .ant-tree-treenode {\n    width: 100% !important;\n    height: 32px !important;\n    line-height: 32px !important;\n  }\n  \n  .tree-panel .ant-tree .ant-tree-list .ant-tree-list-holder .ant-tree-node-content-wrapper {\n    width: 100% !important;\n    display: flex !important;\n    padding: 0 4px !important;\n    height: 32px !important;\n    line-height: 32px !important;\n  }\n  \n  .tree-panel .ant-tree .ant-tree-list .ant-tree-list-holder .ant-tree-title {\n    display: flex !important;\n    width: 100% !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n  }\n  \n  /* \u786E\u4FDD\u590D\u9009\u6846\u53EF\u4EE5\u70B9\u51FB */\n  .tree-panel .ant-tree .ant-tree-checkbox {\n    pointer-events: auto !important;\n    z-index: 10 !important;\n  }\n  \n  .tree-panel .ant-tree .ant-tree-checkbox-wrapper {\n    pointer-events: auto !important;\n    z-index: 10 !important;\n  }\n  \n  .tree-panel .ant-tree .ant-tree-node-content-wrapper {\n    pointer-events: auto !important;\n  }\n  \n  /* \u786E\u4FDD\u6807\u9898\u5185\u5BB9\u4E0D\u4F1A\u963B\u6B62\u590D\u9009\u6846\u70B9\u51FB */\n  .tree-panel .ant-tree .ant-tree-title {\n    pointer-events: none !important;\n  }\n  \n  .tree-panel .ant-tree .ant-tree-title > * {\n    pointer-events: none !important;\n  }\n  \n  /* \u786E\u4FDD\u6574\u4E2A\u6807\u9898\u533A\u57DF\u4E0D\u4F1A\u963B\u6B62\u590D\u9009\u6846\u70B9\u51FB\uFF0C\u4F46\u5141\u8BB8\u60AC\u505C\u663E\u793A Tooltip */\n  .tree-panel .ant-tree .ant-tree-node-content-wrapper:hover .ant-tree-title {\n    pointer-events: none !important;\n  }\n  \n  .tree-panel .ant-tree-switcher .anticon {\n    color: #bfbfbf !important;\n  }\n  \n  .tree-panel .ant-tree-switcher {\n    padding: 0 2px !important;\n    width: 18px !important;\n  }\n  \n  .tree-panel .tree-node-add-button {\n    color: #bfbfbf !important;\n  }\n  \n  .tree-panel .tree-node-add-button:hover {\n    color: #1890ff !important;\n  }\n  \n  .compact-tree .ant-tree-treenode {\n    padding: 0 !important;\n  }\n  \n  .tree-panel .ant-tree {\n    width: 100% !important;\n  }\n  \n  .tree-panel .ant-tree .ant-tree-list {\n    width: 100% !important;\n  }\n  \n  .tree-panel .ant-tree .ant-tree-list .ant-tree-list-holder {\n    width: 100% !important;\n  }\n";
/**
 * 通用树面板组件
 */
var GenericPanelTree = forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.title, title = _d === void 0 ? "数据树" : _d, _e = _a.treeData, treeData = _e === void 0 ? [] : _e, _f = _a.loading, loading = _f === void 0 ? false : _f, _g = _a.buttons, buttons = _g === void 0 ? [] : _g, onSelect = _a.onSelect, onMenuClick = _a.onMenuClick, onRefresh = _a.onRefresh, _h = _a.height, height = _h === void 0 ? 400 : _h, _j = _a.showSearch, showSearch = _j === void 0 ? true : _j, _k = _a.searchPlaceholder, searchPlaceholder = _k === void 0 ? "搜索..." : _k, _l = _a.showLine, showLine = _l === void 0 ? true : _l, _m = _a.showIcon, showIcon = _m === void 0 ? false : _m, _o = _a.defaultExpandAll, defaultExpandAll = _o === void 0 ? true : _o, _p = _a.defaultExpandedKeys, defaultExpandedKeys = _p === void 0 ? [] : _p, _q = _a.defaultSelectedKeys, defaultSelectedKeys = _q === void 0 ? [] : _q, _r = _a.menuItems, menuItems = _r === void 0 ? [] : _r, switcherIcon = _a.switcherIcon, 
    // 添加到参数列表
    selectedKeys = _a.selectedKeys, expandedKeys = _a.expandedKeys, onExpand = _a.onExpand, _s = _a.showActions, showActions = _s === void 0 ? true : _s, onEdit = _a.onEdit, onDelete = _a.onDelete, headerPadding = _a.headerPadding, _t = _a.cardProps, cardProps = _t === void 0 ? {} : _t, customMenuButton = _a.customMenuButton, 
    // 复选框相关参数
    _u = _a.checkable, 
    // 复选框相关参数
    checkable = _u === void 0 ? false : _u, externalCheckedKeys = _a.checkedKeys, onCheck = _a.onCheck, _v = _a.defaultCheckedKeys, defaultCheckedKeys = _v === void 0 ? [] : _v, _w = _a.checkStrictly, checkStrictly = _w === void 0 ? false : _w, 
    // 权限相关参数
    _x = _a.disabledKeys, 
    // 权限相关参数
    disabledKeys = _x === void 0 ? [] : _x, _y = _a.rolePermissionSources, rolePermissionSources = _y === void 0 ? {} : _y, resetKey = _a.resetKey, 
    // 自定义节点标题渲染
    nodeTitleRender = _a.nodeTitleRender, 
    // 数据源引用
    dataSourceRef = _a.dataSourceRef, 
    // 布局相关
    _z = _a.customLayout, 
    // 布局相关
    customLayout = _z === void 0 ? false : _z, className = _a.className, style = _a.style, extra = _a.extra;
    // 状态定义
    var _0 = useState(""), searchValue = _0[0], setSearchValue = _0[1];
    var _1 = useState(defaultExpandedKeys), internalExpandedKeys = _1[0], setInternalExpandedKeys = _1[1];
    var _2 = useState(defaultCheckedKeys), internalCheckedKeys = _2[0], setInternalCheckedKeys = _2[1];
    var _3 = useState(true), autoExpandParent = _3[0], setAutoExpandParent = _3[1];
    var _4 = useState(treeData), filteredTreeData = _4[0], setFilteredTreeData = _4[1];
    var _5 = useState(0), treeContainerHeight = _5[0], setTreeContainerHeight = _5[1];
    var _6 = useState(false), isUserInteracting = _6[0], setIsUserInteracting = _6[1];
    var containerRef = useRef(null);
    var treeDataRef = useRef(treeData);
    var lastResetKeyRef = useRef("");
    var hasInitializedRef = useRef(false);
    var lastAssignedIdsRef = useRef("");
    // 更新 treeDataRef
    useEffect(function () {
        treeDataRef.current = treeData;
    }, [treeData]);
    // 使用外部 checkedKeys 或内部状态
    var checkedKeys = externalCheckedKeys !== undefined
        ? externalCheckedKeys
        : internalCheckedKeys;
    // 暴露给父组件的方法
    useImperativeHandle(ref, function () { return ({
        getSelectedPermissions: function () {
            if (!(dataSourceRef === null || dataSourceRef === void 0 ? void 0 : dataSourceRef.current)) {
                return [];
            }
            // 只保留叶子节点的权限ID（排除模块节点）
            var permissionIds = checkedKeys.filter(function (key) {
                var isPermissionNode = function (permissions, targetKey) {
                    for (var _i = 0, permissions_1 = permissions; _i < permissions_1.length; _i++) {
                        var permission = permissions_1[_i];
                        if (permission.id === targetKey &&
                            permission.type === "FUNCTION") {
                            return true;
                        }
                        if (permission.children &&
                            isPermissionNode(permission.children, targetKey)) {
                            return true;
                        }
                    }
                    return false;
                };
                return isPermissionNode(dataSourceRef.current, String(key));
            });
            // 将选中的ID转换为权限项数组
            var selectedPermissions = permissionIds
                .map(function (id) {
                var findPermission = function (permissions, targetId) {
                    for (var _i = 0, permissions_2 = permissions; _i < permissions_2.length; _i++) {
                        var permission = permissions_2[_i];
                        if (permission.id === targetId) {
                            return permission;
                        }
                        if (permission.children) {
                            var found = findPermission(permission.children, targetId);
                            if (found)
                                return found;
                        }
                    }
                    return null;
                };
                return findPermission(dataSourceRef.current, String(id));
            })
                .filter(Boolean);
            return selectedPermissions;
        },
        getSelectedKeys: function () {
            return checkedKeys;
        },
    }); }, [checkedKeys, dataSourceRef]);
    // 当 resetKey 变化时，强制重置组件状态
    useEffect(function () {
        if (resetKey && resetKey !== lastResetKeyRef.current) {
            lastResetKeyRef.current = resetKey;
            setIsUserInteracting(false);
            lastAssignedIdsRef.current = "__FORCE_UPDATE__";
            hasInitializedRef.current = false;
            setInternalCheckedKeys(defaultCheckedKeys);
            setInternalExpandedKeys(defaultExpandedKeys);
        }
    }, [resetKey, defaultCheckedKeys, defaultExpandedKeys]);
    // 使用外部expandedKeys或内部状态
    var currentExpandedKeys = expandedKeys || internalExpandedKeys;
    // 处理 disabledKeys：在树数据中标记禁用的节点
    var processedTreeData = useMemo(function () {
        if (disabledKeys.length === 0 && !nodeTitleRender) {
            return treeData;
        }
        var processNode = function (node, level) {
            if (level === void 0) { level = 1; }
            var isDisabled = disabledKeys.includes(node.key);
            var sources = rolePermissionSources[node.key] || [];
            var processedNode = __assign(__assign({}, node), { disabled: isDisabled || node.disabled });
            // 如果有自定义节点标题渲染函数，使用它
            if (nodeTitleRender) {
                processedNode = __assign(__assign({}, processedNode), { title: nodeTitleRender(node, level) });
            }
            // 处理子节点
            if (node.children) {
                processedNode.children = node.children.map(function (child) {
                    return processNode(child, level + 1);
                });
            }
            return processedNode;
        };
        return treeData.map(function (node) { return processNode(node, 1); });
    }, [treeData, disabledKeys, rolePermissionSources, nodeTitleRender]);
    // 从节点标题中提取文本（支持 React 节点）
    var getNodeTitleText = useCallback(function (node) {
        if (typeof node.title === "string") {
            return node.title;
        }
        // 从React元素中提取文本
        var extractTextFromElement = function (element) {
            if (typeof element === "string")
                return element;
            if (typeof element === "number")
                return element.toString();
            if (!element)
                return "";
            if (element.props && element.props.children) {
                if (Array.isArray(element.props.children)) {
                    return element.props.children.map(extractTextFromElement).join(" ");
                }
                return extractTextFromElement(element.props.children);
            }
            return "";
        };
        return extractTextFromElement(node.title);
    }, []);
    // 过滤树数据
    var filterTree = React.useCallback(function (value) {
        var expandKeys = [];
        // 递归查找匹配节点及其父节点
        var filterData = function (data) {
            return data
                .map(function (node) {
                var titleText = getNodeTitleText(node);
                var matchNode = titleText
                    .toLowerCase()
                    .includes(value.toLowerCase());
                // 处理子节点
                var children = node.children ? filterData(node.children) : [];
                var matchChildren = children.length > 0;
                // 如果自身匹配或有匹配的子节点，则保留节点
                if (matchNode || matchChildren) {
                    expandKeys.push(node.key);
                    return __assign(__assign({}, node), { children: children.length > 0 ? children : undefined });
                }
                return null;
            })
                .filter(function (node) { return node !== null; });
        };
        var filtered = filterData(processedTreeData);
        setFilteredTreeData(filtered);
        if (!expandedKeys) {
            setInternalExpandedKeys(expandKeys);
        }
        setAutoExpandParent(true);
    }, [processedTreeData, expandedKeys, getNodeTitleText]);
    // 处理节点选择（当没有复选框时）
    var handleSelect = useCallback(function (selectedKeys, info) {
        if (onSelect) {
            onSelect(selectedKeys, info);
        }
    }, [onSelect]);
    // 当原始树数据变化时，更新过滤后的树数据
    useEffect(function () {
        if (searchValue) {
            filterTree(searchValue);
        }
        else {
            setFilteredTreeData(processedTreeData);
        }
    }, [processedTreeData, searchValue, filterTree]);
    // 当外部expandedKeys变化时，同步到内部状态
    useEffect(function () {
        if (expandedKeys) {
            setInternalExpandedKeys(expandedKeys);
        }
    }, [expandedKeys]);
    // 添加这个新的 useEffect 以处理 defaultExpandAll
    useEffect(function () {
        if (defaultExpandAll &&
            processedTreeData.length > 0 &&
            !expandedKeys &&
            !searchValue &&
            !hasInitializedRef.current) {
            // 收集所有节点的 key
            var getAllKeys_1 = function (nodes) {
                var keys = [];
                nodes.forEach(function (node) {
                    keys.push(node.key);
                    if (node.children && node.children.length > 0) {
                        keys = __spreadArray(__spreadArray([], keys, true), getAllKeys_1(node.children), true);
                    }
                });
                return keys;
            };
            var allKeys = getAllKeys_1(processedTreeData);
            setInternalExpandedKeys(allKeys);
            setAutoExpandParent(true);
            hasInitializedRef.current = true;
        }
    }, [processedTreeData, defaultExpandAll, expandedKeys, searchValue]);
    // 同步选中的键 - 当树数据变化时更新（仅在非用户交互时）
    useEffect(function () {
        if (checkable &&
            processedTreeData.length > 0 &&
            !isUserInteracting &&
            externalCheckedKeys === undefined) {
            // 从树数据中提取已分配的权限ID（如果有 isAssigned 标记）
            var extractAssignedIds_1 = function (nodes) {
                var ids = [];
                nodes.forEach(function (node) {
                    if (node.isAssigned &&
                        node.type !== "MODULE") {
                        ids.push(node.key);
                    }
                    if (node.children) {
                        ids.push.apply(ids, extractAssignedIds_1(node.children));
                    }
                });
                return ids;
            };
            var assignedIds = extractAssignedIds_1(processedTreeData);
            if (assignedIds.length > 0) {
                var assignedIdsSignature = __spreadArray([], assignedIds, true).sort().join(",");
                if (assignedIdsSignature !== lastAssignedIdsRef.current) {
                    lastAssignedIdsRef.current = assignedIdsSignature;
                    setInternalCheckedKeys(assignedIds);
                }
            }
        }
    }, [processedTreeData, checkable, isUserInteracting, externalCheckedKeys]);
    // 计算树容器高度
    useEffect(function () {
        if (containerRef.current) {
            var updateHeight = function () {
                if (containerRef.current) {
                    // 获取 Card 的实际高度
                    var cardHeight = containerRef.current.offsetHeight;
                    // Card header 高度（约 56px）+ body padding (12px * 2 = 24px)
                    // search 高度（如果显示，约 40px + marginTop 16px）
                    // tree-container 的 marginTop (16px)
                    var headerHeight = 56;
                    var searchHeight = showSearch ? 56 : 0; // search input height + margin
                    var height_1 = cardHeight - headerHeight - 24 - searchHeight - 16;
                    setTreeContainerHeight(height_1 > 0 ? height_1 : 0);
                }
            };
            updateHeight();
            var resizeObserver_1 = new ResizeObserver(updateHeight);
            resizeObserver_1.observe(containerRef.current);
            return function () { return resizeObserver_1.disconnect(); };
        }
    }, [showSearch]);
    // 处理搜索
    var handleSearch = function (value) {
        setSearchValue(value);
        if (value) {
            filterTree(value);
        }
        else {
            setFilteredTreeData(processedTreeData);
            if (!expandedKeys) {
                // 清空搜索时展开所有节点
                if (defaultExpandAll) {
                    var getAllKeys_2 = function (nodes) {
                        var keys = [];
                        nodes.forEach(function (node) {
                            keys.push(node.key);
                            if (node.children) {
                                keys.push.apply(keys, getAllKeys_2(node.children));
                            }
                        });
                        return keys;
                    };
                    setInternalExpandedKeys(getAllKeys_2(processedTreeData));
                    setAutoExpandParent(true);
                }
                else {
                    setInternalExpandedKeys(defaultExpandedKeys);
                }
            }
        }
    };
    // 处理复选框变化
    var handleCheck = useCallback(function (checkedKeysValue, info) {
        if (!checkable) {
            return;
        }
        // 确保 checkedKeys 是数组
        var newCheckedKeys = [];
        if (Array.isArray(checkedKeysValue)) {
            newCheckedKeys = checkedKeysValue;
        }
        else if (checkedKeysValue && typeof checkedKeysValue === "object") {
            // 处理 { checked: [], halfChecked: [] } 格式
            var _a = checkedKeysValue.checked, checked = _a === void 0 ? [] : _a;
            newCheckedKeys = checked;
        }
        else {
            return;
        }
        // 设置用户交互标志
        setIsUserInteracting(true);
        // 更新内部状态（如果使用内部状态）
        if (externalCheckedKeys === undefined) {
            setInternalCheckedKeys(newCheckedKeys);
        }
        // 调用外部回调
        if (onCheck) {
            onCheck(newCheckedKeys, info);
        }
        // 延迟重置用户交互标志
        setTimeout(function () {
            setIsUserInteracting(false);
        }, 500);
    }, [checkable, externalCheckedKeys, onCheck]);
    // 处理展开/折叠
    var handleExpand = function (newExpandedKeys, info) {
        if (onExpand) {
            // 如果有外部onExpand处理器，调用它
            onExpand(newExpandedKeys, info);
        }
        else {
            // 否则使用内部状态
            setInternalExpandedKeys(newExpandedKeys);
        }
        setAutoExpandParent(false);
    };
    // 渲染树节点标题，包括操作按钮
    var renderNodeTitle = useCallback(function (node) {
        // 使用节点自己的菜单项，如果没有则使用全局菜单项
        var nodeMenuItems = node.menuItems || menuItems || [];
        var menu = (_jsx(Menu, __assign({ onClick: function (_a) {
                var key = _a.key;
                return onMenuClick && onMenuClick(node, key);
            } }, { children: nodeMenuItems.map(function (item) { return (_jsx(Menu.Item, { children: item.label }, item.key)); }) })));
        // 如果节点标题已经是 React 节点（来自 nodeTitleRender），直接使用
        var titleContent = typeof node.title === "string" ? (_jsx(Text, __assign({ ellipsis: true, style: { flex: 1, minWidth: 0 } }, { children: node.title }))) : (_jsx("div", __assign({ style: { flex: 1, minWidth: 0 } }, { children: node.title })));
        return (_jsxs("div", __assign({ style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                gap: "8px",
            } }, { children: [titleContent, _jsxs("div", __assign({ style: {
                        display: "flex",
                        alignItems: "center",
                        flexShrink: 0,
                        justifyContent: "flex-end",
                        gap: "8px",
                        minWidth: "24px",
                    } }, { children: [showActions && onEdit && (_jsx(Button, { type: "text", icon: _jsx(EditOutlined, {}), size: "small", onClick: function (e) {
                                e.stopPropagation();
                                onEdit(node);
                            }, style: {
                                padding: "0 4px",
                                color: "#bfbfbf",
                                fontSize: "12px",
                            }, title: "\u7F16\u8F91" })), showActions && onDelete && (_jsx(Button, { type: "text", icon: _jsx(DeleteOutlined, {}), size: "small", onClick: function (e) {
                                e.stopPropagation();
                                onDelete(node);
                            }, style: {
                                padding: "0 4px",
                                color: "#bfbfbf",
                                fontSize: "12px",
                            }, title: "\u5220\u9664" })), customMenuButton && customMenuButton(node), !customMenuButton &&
                            onMenuClick &&
                            nodeMenuItems &&
                            nodeMenuItems.length > 0 && (_jsx(Dropdown, __assign({ overlay: menu, trigger: ["click"] }, { children: _jsx(Button, { type: "text", icon: _jsx(EllipsisOutlined, {}), size: "small", onClick: function (e) { return e.stopPropagation(); }, style: {
                                    padding: "0 4px",
                                    color: "#bfbfbf",
                                    fontSize: "12px",
                                }, className: "tree-node-add-button", title: "\u66F4\u591A\u64CD\u4F5C" }) })))] }))] })));
    }, [menuItems, onMenuClick, showActions, onEdit, onDelete, customMenuButton]);
    // 添加自定义标题到树数据
    var addCustomTitleToData = useCallback(function (data) {
        return data.map(function (node) {
            var newNode = __assign(__assign({}, node), { 
                // 只有在非 customLayout 模式或需要显示操作按钮时才使用 renderNodeTitle
                // customLayout 模式下直接使用原始 title，避免阻止复选框点击
                title: customLayout ? node.title : renderNodeTitle(node) });
            if (node.children) {
                newNode.children = addCustomTitleToData(node.children);
            }
            return newNode;
        });
    }, [customLayout, renderNodeTitle]);
    // 带自定义标题的树数据
    var treeDataWithCustomTitle = useMemo(function () {
        return addCustomTitleToData(filteredTreeData);
    }, [addCustomTitleToData, filteredTreeData]);
    // 构建默认右上角刷新按钮
    var defaultButtons = onRefresh
        ? [
            _jsx(Button, __assign({ type: "link", icon: _jsx(ReloadOutlined, {}), onClick: onRefresh, style: {
                    fontSize: "12px",
                    padding: "0 8px",
                    color: "#bfbfbf",
                } }, { children: "\u5237\u65B0" }), "refresh"),
        ]
        : [];
    // 增强 switcherIconFunc 函数
    var switcherIconFunc = function (props) {
        var expanded = !!props.expanded;
        // 添加内联样式，确保不会被其他样式覆盖
        var iconStyle = {
            color: "#bfbfbf",
            transform: "none !important",
            transition: "none !important",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
        };
        if (expanded) {
            // 向下箭头 - 使用内置图标
            return _jsx(CaretDownOutlined, { style: iconStyle });
        }
        else {
            // 向右箭头 - 使用内置图标
            return _jsx(CaretRightOutlined, { style: iconStyle });
        }
    };
    // 合并默认按钮和自定义按钮
    var allButtons = __spreadArray(__spreadArray([], defaultButtons, true), buttons, true);
    // 如果使用自定义布局（搜索框固定，树可滚动）
    if (customLayout) {
        return (_jsxs(_Fragment, { children: [_jsx("style", { children: globalStyles }), _jsx(Card, __assign({ title: title, extra: extra ||
                        (allButtons.length > 0 ? _jsx(Space, { children: allButtons }) : null), className: className, loading: loading, style: __assign({ height: typeof height === "number" ? "".concat(height, "px") : height }, style), styles: __assign(__assign({ body: {
                            padding: "12px 24px",
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            overflow: "hidden",
                        } }, cardProps.styles), { header: headerPadding
                            ? { padding: headerPadding }
                            : (_b = cardProps.styles) === null || _b === void 0 ? void 0 : _b.header }) }, cardProps, { children: _jsxs("div", __assign({ style: {
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            boxSizing: "border-box",
                            overflow: "hidden",
                        } }, { children: [showSearch && (_jsx("div", __assign({ style: {
                                    flexShrink: 0,
                                    paddingBottom: 16,
                                    backgroundColor: "white",
                                    zIndex: 10,
                                } }, { children: _jsx(Input, { placeholder: searchPlaceholder, prefix: _jsx(SearchOutlined, {}), value: searchValue, onChange: function (e) { return handleSearch(e.target.value); }, allowClear: true }) }))), _jsxs("div", __assign({ style: {
                                    flex: 1,
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                    minHeight: 0,
                                    paddingRight: "8px",
                                    paddingBottom: "10px",
                                    boxSizing: "border-box",
                                    scrollbarWidth: "thin",
                                    scrollbarColor: "#d9d9d9 #f0f0f0",
                                } }, { children: [loading ? (_jsx("div", __assign({ style: { textAlign: "center", padding: 50 } }, { children: _jsx(Empty, { description: "\u52A0\u8F7D\u4E2D..." }) }))) : (_jsx(Tree, { checkable: checkable, checkedKeys: checkedKeys, onCheck: handleCheck, onSelect: handleSelect, expandedKeys: currentExpandedKeys, onExpand: handleExpand, autoExpandParent: autoExpandParent, treeData: treeDataWithCustomTitle, showLine: { showLeafIcon: false }, showIcon: showIcon, checkStrictly: checkStrictly, defaultCheckedKeys: defaultCheckedKeys, style: {
                                            background: "transparent",
                                        }, 
                                        // customLayout 模式下不使用 titleRender，直接使用 treeData 中的 title
                                        // 这样可以避免阻止复选框的点击事件
                                        filterTreeNode: function (node) {
                                            if (!searchValue)
                                                return true;
                                            var titleText = getNodeTitleText(node);
                                            return titleText
                                                .toLowerCase()
                                                .includes(searchValue.toLowerCase());
                                        } })), filteredTreeData.length === 0 && !loading && (_jsx("div", __assign({ style: { textAlign: "center", padding: "20px 0" } }, { children: _jsx(Empty, { description: "\u6682\u65E0\u6570\u636E" }) })))] }))] })) }))] }));
    }
    // 默认布局（Card 包装）
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: globalStyles }), _jsx("div", __assign({ ref: containerRef, style: __assign({ flex: 1, minHeight: 0 }, style), className: className }, { children: _jsxs(Card, __assign({ title: title, extra: extra || (_jsx(Space, { children: allButtons.map(function (button, index) {
                            return React.cloneElement(button, {
                                key: index,
                            });
                        }) })), className: "tree-panel", loading: loading, style: {
                        height: typeof height === "number" ? "".concat(height, "px") : height,
                    }, styles: __assign(__assign({ body: {
                            padding: "0 16px",
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            overflow: "hidden",
                            rowGap: 16,
                        } }, cardProps.styles), { 
                        // 确保 headerPadding 不被 cardProps.styles 覆盖
                        header: headerPadding
                            ? { padding: headerPadding }
                            : (_c = cardProps.styles) === null || _c === void 0 ? void 0 : _c.header }) }, cardProps, { children: [showSearch && (_jsx("div", __assign({ className: "tree-search-container", style: {} }, { children: _jsx(Search, { placeholder: searchPlaceholder, allowClear: true, onChange: function (e) {
                                    return handleSearch(e.target.value);
                                } }) }))), filteredTreeData.length > 0 ? (_jsx("div", __assign({ className: "tree-container", style: {
                                flex: 1,
                                minHeight: 0,
                                overflow: "auto",
                                paddingBottom: "32px",
                            } }, { children: _jsx(Tree, { className: "full-width-tree compact-tree", showLine: false, showIcon: showIcon, onExpand: handleExpand, expandedKeys: currentExpandedKeys, autoExpandParent: autoExpandParent, onSelect: handleSelect, defaultSelectedKeys: defaultSelectedKeys, selectedKeys: selectedKeys, defaultExpandAll: defaultExpandAll, treeData: treeDataWithCustomTitle, switcherIcon: switcherIconFunc, 
                                // 复选框相关属性
                                checkable: checkable, checkedKeys: checkedKeys, onCheck: handleCheck, defaultCheckedKeys: defaultCheckedKeys, checkStrictly: checkStrictly, style: {
                                    width: "100%",
                                    fontSize: "14px",
                                } }) }))) : (_jsx("div", __assign({ style: {
                                flex: 1,
                                minHeight: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            } }, { children: _jsx(Empty, { description: "\u6682\u65E0\u6570\u636E" }) })))] })) }))] }));
});
GenericPanelTree.displayName = "GenericPanelTree";
export default GenericPanelTree;
